<template functional>
  <b-card
    no-body
    class="rounded-0 shadow-none phairify-cc-box"
    :class="data.staticClass || ''"
  >
    <b-card-header class="phairify-cc-box-header rounded-0">
      <b-row align-v="center">
        <b-col
          class="d-flex align-items-center phairify-cc-box__title-wrapper"
          cols="10"
          lg="11"
        >
          <slot name="title">
            <div class="d-inline-flex">
              <h2 class="v2_font_size_32 v2_font_weight_semibold v2_color_black my-2">
                {{ props.titleText }}
              </h2>
            </div>
          </slot>
        </b-col>
        <b-col cols="2" lg="1" class="d-flex justify-content-center">
          <b-button
            class="phairify-hide-button py-0 py-md-1"
            v-b-toggle="`card-content-${props.collapseKey}`"
            variant="link"
          >
            <span class="when-closed">
              <span class="bv-d-sm-down-none">EXPAND</span>
              <i class="mdi mdi-arrow-collapse-down d-md-none"/>
            </span>
            <span class="when-opened">
              <span class="bv-d-sm-down-none">COLLAPSE</span>
              <i class="mdi mdi-arrow-collapse-up d-md-none"/>
            </span>
          </b-button>
        </b-col>
      </b-row>
    </b-card-header>
    <b-collapse
      :id="`card-content-${props.collapseKey}`"
      class="phairify-cc-box-body"
      visible
    >
      <slot />
    </b-collapse>
  </b-card>
</template>

<script>
export default {
  name: 'CollapsedCard',
  props: {
    titleText: {
      type: String,
    },
    collapseKey: {
      required: true,
      type: String,
    },
  },
};
</script>

<style lang="scss">
@import '../../../sass/variables_mixins.scss';

.phairify-cc-box {
  padding: 5px 10px 0 10px;
  border: 2px solid rgba($phairify_secondary_color_grey, 0.25);

  hr {
    margin-right: -10px;
    margin-left: -10px;
  }
}

.phairify-cc-box-header {
  border: none;
}

.phairify-cc-box-title {
  @include phairify_heading_bold_18;
}
.phairify-cc-box__title-wrapper {
  button.btn.btn-primary {
    @include phairify_primary_button_enabled;
  }
}
</style>
